module.exports = __webpack_public_path__ + "static/media/Green_Chat_Bubble.7b3e23e3.png";